import bg from "../el-ui-locales/bg";

export default {
  ...bg,

  At: 'На',
  select_team: "Изберете екип",
  type_of_preview: "Вид преглед",
  detail_view: "Детайлен преглед",
  summary_view: "Обобщен преглед",
  
  // presence drawer
  select_an_employee: "Изберете служител",
  enter_date: "Въведете дата",
  presence_type: "Тип присъствие",
  strict_time: "Фиксирано време",
  select_work_shift: "Изберете смяна",
  until_the_end_of_the_week: "до края на седмицата",
  until_the_end_of_the_month: "до края на месеца",
  edit_schedule: "Редактиране на графика",
  required: "Задължително",
  sliding_time: "Плъзгащо време",
  final_start_time: "Краен час за начало",
  number_of_working_hours: "Брой работни часове",

  are_you_sure: "Сигурни ли сте?",
  confirm: "Потвърдете",
  are_you_sure_update_presence: "Сигурни ли сте, че искате да актуализирате това присъствие?",
  yes_update_it: "Да, актуализирайте го",
  are_you_sure_create_presence: "Сигурни ли сте, че искате да създадете това присъствие?",
  yes_create_it: "Да, създадете го",
  are_you_sure_delete_presence: "Сигурни ли сте, че искате да изтриете това присъствие?",
  yes_delete_it: "Да, изтрийте го",
  are_you_sure_create_scheduler: "Сигурни ли сте, че искате да създадете този график/ци?",
  yes_create_scheduler: "Да, създай го/ги",

  // expand button texts in weekly totals
  view_detail_work: "Преглед на детайлите на работата",
  hide_detail_work: "Скриване на детайлите на работата",
  
  // navigation bar
  dashboard: "Начало",
  presence: "Присъствие",
  calendar: "Календар",
  my_presence: "Моят Присъствие",
  my_calendar: "Моят Календар",
  reports: "Отчети",
  shift_reports: "Отчет за смените",
  my_profile: "Моят Профил",
  hi: "Здравейте",
  logout: "Излизане от профила",
  // footer
  made_by: "изработено от",
  version: "Версия",
  cookie_policy: "Политика за изпозване на бисквитки",
  privacy_policy: "Политика за поверителност",
  // tables
  no_data_available: "Няма данни",
  showing_entries: "Показва се {from} до {to} от {total} записа",
  go_to: "Отидете на",
  page_size: "{size}/страница",
  person1: "Лице",
  start_date: "Начална дата",
  department: "Отдел",
  team: "Eкип",
  type_of_absence: "Вид отсъствие",
  requested_period: "Искан период",
  requested_days: "Заявени дни",
  submitted_at: "Изпратено на",
  period: "Период",
  years_in_company: "Години във фирмата",
  pending_absence_requests: "Чакащи заявки за отсъствие",
  pending_absence_request: "Чакащи заявка за отсъствие",
  todays_absences: "Днешните отсъствия",
  todays_absence: "Днешното отсъствие",
  start_tomorrow_absences: "Хора, чиито отсъствия започват от утре",
  start_tomorrow_absence: "Лице, чието отсъствие започва от утре",
  upcoming_work_anniversary: "Предстояща годишнина от работата",
  upcoming_work_birthdays: "Предстоящи рождени дни",

  // Presence
  success: "Успешно",
  search: "Търсене",
  your_input_was_saved_successfully: "Вашето въвеждане е запазено успешно",
  //**********from absent my_presence.php**********//
  today_presence: "Днешното присъствие",
  clock_in: "Работа От",
  clock_out: "Работа До",
  break_start: "Почивка От",
  break_stop: "Почивка До",
  private_exit_start: "Излизане Начало",
  private_exit_stop: "Излизане Край",
  From: "От",
  To: "До",
  monday: "Понеделник",
  tuesday: "Вторник",
  wednesday: "Сряда",
  thursday: "Четвъртък",
  friday: "Петък",
  saturday: "Събота",
  sunday: "Недяла",
  paid_break: "Платена почивка",
  absence: "Отсъствие",
  total_regular_time: "Общо редовно време",
  private_exit: "Излизане",
  per_page: " На страница",
  weekly_presence: "Седмично присъствие",
  prev_week: "Предишна седмица",
  week: "Седмица",
  next_week: "Следваща седмица",
  no_data: "Няма данни",
  presence_history: "История на присъствието",
  cancel: "Отказ",
  cancelled: "Отказано!",
  field_work_start: "Работа на терен начало",
  field_work_stop: "Работа на терен край",
  holiday: "Празник",
  unauth_absence: "Неразрешено отсъствие",
  scheduled_time: "Планирано време",
  //--------from absent presence.php--------//
  work: "Работа",
  break: "Платена почивка",
  field_work: "Работа на терен",
  create: "Създаване",
  update: "Актуализиране",
  delete: "Изтриване",
  close: "Затвори",
  save_changes: "Запази промените",
  monday_short: "Пон",
  tuesday_short: "Вто",
  wednesday_short: "Сря",
  thursday_short: "Чет",
  friday_short: "Пет",
  saturday_short: "Съб",
  sunday_short: "Нед",
  updated_end_time: "Актуализиран<br>краен час",
  edit_presence: "Редактиране на присъствието",
  person: "Личност",
  date: "Дата",
  type: "Тип",
  action: "Действие",
  updated_start_time: "Актуализиран<br>начален час",
  prev_start_time: "Предишен<br>начален час",
  previous_start_time: "Предишен начален час",
  prev_end_time: "Предишен<br>краен час",
  previous_end_time: "Предишен краен час",
  duration: "Продължителност",
  last_comment: "Последен коментар",
  last_updated_by: "Последна актуализация от",
  last_updated_at: "Последна актуализация на",
  employee: "Служител",
  select_time: "Изберете време",
  comment: "Коментар",
  holiday: "Празник",
  total_for: "Общо за",
  comment_for_this_presence: "Коментар за това присъствие",
  updated_from_overlapped_presence: "Актуализирано от припокрито присъствие",
  deleted_from_overlapped_presence: "Изтрито от припокрито присъствие",
  reason_for_updating: "Причина за актуализация",
  max_length_is_250_characters: "Максималната дължина е 250 знака.",
  work_shift: "Работна смяна",
  rest_day: "Почивен ден",
  presence_on_rest_day: "Присъствие в почивен ден",
  selected_day: "избраният ден",
  schedule_for: "График за",
  nothing_selected: "Не е избрано нищо",
  at: "На:",
  logged_at: "Влизане в:",
  shift_name: "Име на смяната:",
  shift_start: "Начало на смяната:",
  shift_end: "Край на смяната:",
  custom: "Персонализирана",
  presence_on_holiday: "Работа по време на празник",
  presence_on_absence: "Работа по време на отсъствие",
  break_on_holiday: "Платена почивка по време на празник",
  break_on_absence: "Платена почивка по време на отсъствие",
  field_work_on_holiday: "Работа на терен по време на празник",
  field_work_on_absence: "Работа на терен по време на отсъствие",
  presence_on_rest_day: "Присъствие в почивен ден",
  field_work_on_rest_day: "Работа на терен по време на почивен ден",
  break_on_rest_day: "Платена почивка по време на почивен ден",
  presence_on_night_work: "Присъствие по време на нощна работа",
  field_work_on_night_work: "Работа на терен по време на нощна работа",
  break_on_night_work: "Платена почивка по време на нощна работа",
  exceeded_break: "Превишена почивка",
  overtime_work: "Извънреден труд",
  unpaid_absence: "Неплатено отсъствие",
  description: "Описание",
  weekly_total_time: "Общо време за седмицата",
  no_results_found_matching_your_search: "Няма намерени резултати, отговарящи на вашето търсене",
  start: "Начало",
  end: "Край",
  // end of presence
  // my calendar 
 schedule_vacation_days: "Планирайте годишния отпуск",
  schedule_vacation_modal: "Моля, кликнете за начална и крайна дата в календара",
  ok: "Ok",
  remaining: "Оставащи дни",
  pending: "В очакване",
  used: "Изпозвани",
  period_of_usage: "Период за използване",
  calculation_from: "Изчисление от",
  to: "до",
  from: "от",
  of: "на",
  entries: "записи",
  showing: "Показва се",
  create_period: "Кликнете на още една дата за да създадете период",
  period: "Период",
  create_absence: "Създаване на отсъствие",
  employees: "Служители",
  type_of_leave: "Тип на отсъствието",
  personal_days_type: "Тип на персоналните дни",
  select_type_of_leave: "Изберете тип на отсъствието",
  type_of_personal_days: "Изберете тип на персоналните дни",
  comment: "Коментар",
  absence_declied: "Отсъствието е успешно отказано",
  file_uploaded: "Файлът е успешно качен",
  upload_absence_doc: "Качете документ за отсъствието",
  attach_doc: "Прикачи документ",
  choose_files: "Изберете файлове",
  no_file_chosen: "Няма избран файл",
  pdf_size: "PDF файлът не може да бъде по-голям от 1MB",
  files_allowed: "Само PDF, JPG, JPEG файлове са позволени",
  size_of_file: "Един  JPG, JPEG файл не може да бъде по-голям от 10MB",
  max_allowed_files: "Максималният брой файлове е",
  file_limit_exceeded:
    "Ограничението е {fileLimit} файла. Можете да изберете още {remainingFiles} файла.",
  submitting: "Изпраща се...",
  submit: "Изпращане",
  saving: "Запазва се...",
  save_file: "Запазване на документа",
  pdf_file_not_exceed: "PDF файлът не може да бъде по-голям от",
  img_file_not_exceed: "Размерът на файла с изображение не трябва да надвишава",
  my_absence_logs_title: "Моите отсъствия",
  requested_period: "Избран период",
  requested_days: "Избрани дни",
  name_of_vacation: "Наименование на годишен отпуск",
  updated_at: "Обновено на",
  status: "Статус",
  action: "Действие",
  search: "Търсене",
  no_data_available: "Няма данни",
  submitted_by: "Изпратено от:",
  approved_by: "Одобрено от:",
  declined_by: "Отказано от:",
  pending_approval_by: "Очаква одобрение от:",
  on: "На",
  at: "В",
  comment_presence: "Коментар за това присъствие:",
  approve: "Одобри",
  approved: "Одобрено",
  decline:"Отказан",
  declined: "Отказано",
  upload_files: "Прикачени файлове",
  download_files: "Изтеглени файлове",
  decline_absence_request: "Сигурни ли сте, че искате да отхвърлите тази<br>заявка за отсъствие?",
  approve_absence_request: "Сигурни ли сте, че искате да одобрите тази<br>заявка за отсъствие?",
  decline_rest_day_request: "Сигурни ли сте, че искате да откажете тази<br>заявка за почивен ден?",
  write_reason: "Моля, напишете причина",
  decline_it: "Да, откажете го!",
  approve_it: "Да, одобри го!",
  vacation: "Годишна отпуска",
  presonal_days: "Платен отпуск",
  sick_leave: "Отпуск по болест",
  business_trip: "Командировка",
  work_from_home: "Работа от вкъщи",
  extra_days: "Допълнителни дни",
  switched_day: "Променен ден",
  paid_patental_leave: "Платен отпуск по майчинство",
  unpaid_patental_leave: "Неплатен отпуск по майчинство",
  unpaid_leave: "Неплатен отпуск",
  rest_day: "Почивен ден",
  marriage: "За сключване на брак",
  child_marriage: "За женитба на дете",
  adoption_child: "За раждане или осиновяване на дете",
  death_spouse_child: "За смърт на съпруг(а) или дете",
  death_parent_brother_sister: "За смъртта на родител, брат, сестра",
  death_parent_spouse: "За смърт на родител на съпруга(та)",
  death_grandfather_grandmother: "За смъртта на дядо или баба",
  needs_of_employer:
    "За полагане на професионален изпит или друг изпит за нуждите на работодателя",
  natural_disasters: "За природни бедствия",
  moving_family_from_one_to_another_place:
    "За преместването на семейството от едно място на друго",
  moving_family_to_the_same_place:
    "За преместване на семейството на същото място",
  you_get_num_days: ", вие получавате {n} ден. | , вие получавате {n} дни.",
  public_holiday: "Официален празник",
  holiday: "Празник",
  profile_settings: "Настройки на профила",
  update_picture: "Промяна на снимката",
  change_password: "Промяна на паролата",
  email_address: "Имейл адрес",
  full_name: "Име и фамилия",
  full_name_in_docs: "Име и фамилия в документите",
  display_job_position: "Длъжност за показване",
  job_position_in_docs: "Длъжност в документите",
  local_language: "Въведете на вашия локален език.", // still not using
  birthday: "Дата на раждане",
  phone_no: "Телефон No.",
  nationality: "Националност",
  religion: "Религия",
  employment_start_date: "Дата на започване на работа",
  country: "Държава",
  pick_date: "Избери дата",
  symbol_placeholder: "+xx xxx xxx xxxx",
  select: "Изберете",
  pick_employment_date: "Изберете дата за работа",
  save_changes: "Запазете промените",
  reset: "Нулиране",
  // my calendar end
  // team leader calendar
  absence_type: "Вид отпуск",
  select_an_employee:"Изберете служител",
  absence_requests_for_team:"Заявки за отсъствие на екип",
  person2:"Лице",
  use_period:"Период за използване:",
  remaining_days: "Оставащи дни",
  pending_days:"Дни за одобрение",
  used_days: "Използвани дни",
  no_vacations_in_this_period_for_this_user: "За този потребител няма отпуск в този период",
  info: "След отказ не е достъпно никакво действие",
  info_waiting_approval:"Изчаква се за одобрение от",
  pending_approval: "За одобрение",
  decline_approval: "Отказан",
  approved_absence: "Одобрени",
  declined_approval: "Отказани",
  permissions_to_perform_any_actions:"Нямате никакви права за извършване на каквито и да било действия",
  // team leader calendar end
  // Gm and sysadmin calendar start
  edit_comment: "Промяна на коментара",
  comment_required: "Полето коментар е задължително",
  comment_successfully_updated: "Коментарът е успешно променен",
  edit_comment: "Промяна на коментара",
  // Gm and sysadmin calendar end
  // department leader start
  department: "Отдел",
  // department leader end
  // Teams start
  teams: "Екипи",
  team_lead: "Ръководител на Екипа",
  add_team: "Добавяне на Екип",
  team_name: "Име на Екипа",
  team_members: "Членове на Екипа",
  team_successfully_created: "Екипът е създаден успешно",
  team_successfully_deleted: "Екипът е изтрит успешно",
  delete_this_team: "Сигурни ли сте, че искате да изтриете този Екип?",
  not_be_able_to_revert: "Няма да можете да върнете това обратно!",
  yes_decline_it: "Да, изтриий го!",
  select_department: "Изберете отдел",
  team_name_required: "Име на Екипа е задължително",
  select_an_option: "Изберете опция",
  department_required: "Отделът е задължителен",
  team_lead_required: "Ръководител на Екипа трябва да бъде избран",
  create_team: "Създаване на Екип",
  edit_team: "Редактиране на Екипа",
  team_successfully_updated: "Екипът е актуализиран успешно",
  team_successfully_approved: "Екипът е актуализиран успешно",
  team_successfully_declined: "Екипът е актуализиран успешно",
  pending_requests: "При смяна на ръководителите на екипи всички чакащи заявки трябва да бъдат одобрени или отхвърлени",
  approve_all: "Одобри всички",
  decline_all: "Откажи всички",
  approve_requests: "Сигурни ли сте, че искате да одобрите всички заявки?",
  yes_approve_all: "Да, Одобри всички",
  decline_requests: "Сигурни ли сте, че искате да откажете всички заявки?",
  yes_decline_all: "Да, Откажи всички",
  // Teams end
  // Gates start
  gates: "Входове",
  number_of_devices: "Брой устройства",
  name: "Име",
  // Gates end
   // Settings start
  company_settings: "Фирмени настройки",
  company_language: "Език на фирмата:",
  show_qr_code_my_presence_page: 'Показване на QR кода в "Моето присъствие" страница',
  enable_disable_two_factor_via_email: "Активиране/деактивиране на двуфакторно удостоверяване чрез имейл",
  use_pass_reset_3_months: "Задължителна смяна на паролата на всеки 3 месеца.",
  enable_saving_images: "Активирайте запазването на изображения.",
  min_days_before_vacation_request: "Минимум дни преди заявка за ваканция:",
  disable_emails_for_gm: "Деактивиране на имейл за Генерален директор",
  disable_emails_for_dm: "Деактивиране на имейл за Ръководител на отдел",
  disable_emails_for_chairman: "Деактивиране на имейл за Председател",
  allow_approval_for_absence_req: "Разрешаване на одобрение за заявки за отсъствие:",
  general_manager: "Генерален директор",
  human_resources: "Човешки ресурси",
  department_lead: "Ръководител на отдел",
  allways_show_saturday: "Винаги показвай Събота",
  allways_show_sunday: "Винаги показвай Неделя",
  add_shift: "Добавете смяна",
  company_timezone: "Часова зона на фирмата:",
  show_presence_history_for_tm: "Показване на хронологията на присъствието на член на екипа",
  gm_can_schedule_vacation_in_the_past: "Генерален директор може да планира ваканция в миналото",
  sysadmin_can_schedule_vacation_in_the_past: "Системен администратор може да планира ваканция в миналото",
  hr_can_schedule_vacation_in_the_past: "Човешки ресурси може да планира ваканция в миналото",
  dl_can_schedule_vacation_in_the_past: "Ръководителят на отдела може да планира ваканция в миналото",
  tl_can_schedule_vacation_in_the_past: "Ръководителят на екип може да планира ваканция в миналото",
  dm_can_schedule_work_time_and_rest_days: "Ръководителят на отдела може да планира работно време и почивни дни за себе си",
  tl_can_schedule_work_time_and_rest_days: "Ръководителят на екип може да планира работно време и почивни дни за себе си",
  absence_will_be_approved_by: "Отсъствията ще се одобряват от:",
  start_time_rounding_range_margin: "Диапазон на закръгляване на началния час:",
  end_time_rounding_range_margin: "Диапазон на закръгляване на крайния час:",
  flexible_working_hours_margin: "График за гъвкаво работно време:",
  enable_night_work: "Разрешаване на нощен труд",
  define_period_for_logging_working_hours: "Определяне на период за регистриране на работните часове",
  night_work_start_time: "Начало на нощния труд",
  night_work_end_time: "Край на нощния труд",
  logging_period_start_time: "Начало на регистрационния период",
  logging_period_end_time: "Край на регистрационния период",
  night_work_is_turned_on_please_enter_a_night_work_period: "Нощен труд е включен, моля въведете периода на нощен труд!",
  period_for_logging_work_hours_is_turned_on_please_select_work_hours_period: "Периодът за регистриране на работните часове е включен, моля изберете период на работното време!",
  company_settings_successfully_updated: "Фирмените настройки са успешно актуализирани",
  are_you_sure_want_perform_this_action: "Сигурни ли сте, че ще извършите това действие?",
  and: "И",
  or: "ИЛИ", 
  end_time_greater_than_start_time: "Крайният час трябва да е по-голям от началния час за периода на логване.",
  enter_shift_name: "Въведете име на смяна",
  select_timezone: "Изберете часова зона",
  // Settings End
  // NonRoundedPresenceReports Start
  non_rounded_presence_reports: "Незакръглени отчети за присъствие",
  // NonRoundedPresenceReports End
  // Sentice Start
  company_sentice: "Компания:",
  report_prefix: "Отчет",
  sentice_report: "Отчет за клиентите на Sentice",
  // Sentice End
 // Avatar Tab
  upload_or_drop_picture: "Кликнете тук, за да качите или пуснете снимка тук.",
  image_allowed: "Разрешени за качване са само файлове с изображения", //still not using
  image_is_uploaded: "Изображението е качено",
  // Password Tab
  password_updated_successfully: "Паролата е актуализирана успешно",
  password_rules:
    "Паролата трябва да бъде комбинация от поне осем буквено-цифрови знака (малки и главни букви), символи, цифри и препинателни знаци.",
  new_password: "Нова парола",
  repeat_password: "Повтори паролата",
  old_password: "Стара парола",
  code: "Код",
  // Shift Reports
  period_from: "Период от:",
  period_to: "Период до:",
  select_date: "Изберете дата",
  department: "Отдел:",
  generate: "Генерирай",
  export: "Експортирай",
  team: "Екип:",
  user: "Потребител:",
  all_without_deactivated: "Всички, без деактивирани",
  all: "Всички",
  person_report: "Лице",
  day_day: "Ден",
  shiftName: "Смяна",
  dateDate: "Дата",
  shiftStartTime: "Планиран начален час",
  shiftEndTime: "Планиран краен час",
  shiftTotalTime: "Общо планирано",
  total_reports: "Общо",
  shifts_report: "AbSent Отчет за смените",
  invalid_input_data: "Възникна грешка",
  // Calendar Reports
  calendar_reports: "Календарен отчет",
  cumulative_report: "Обобщен отчет",
  absent_cumulative_report: "AbSent Обобщен отчет",
  periodic_report: "Справка по периоди",
  absent_periodic_report: "AbSent Справка по периоди",
  toggle_columns: "Включете колоните:",
  annual_leave_unused: "Годишен отпуск - Неизползван",
  annual_leave_pending: "Годишен отпуск - За одобрение",
  annual_leave_used: "Годишен отпуск - Използван",
  vacation_name: "Назив на годишен одмор",
  personal_days: "Платен отпуск",
  paid_parental_leave: "Платен отпуск по майчинство",
  unpaid_parental_leave: "Неплатен отпуск по майчинство",
  // Presence Reports
  presence_reports: "Отчет за присъствие",
  cumulative: "Обобщен отчет",
  daily: "Дневен",
  detailed: "Детайлно",
  choose_user: "Изберете потребител",
  expected_regular_time: "Очаквано редовно време",
  expected_and_total_time_difference: "Разлика между очакваното и общото време",
  overtime_work: "Извънреден труд",
  total_scheduled: "Общо планирано",
  expected_and_total_time_difference_with_overtime: "Разлика между очакваното, общото време и извънреден труд",
  total_logged_hours: "Общо регистрирани часове",
  unauthorized_absence: "Неразрешено отсъствие",
  scheduled_start_time: "Планиран начален час",
  logged_start_time: "Регистрирано начално време",
  scheduled_end_time: "Планиран краен час",
  logged_end_time: "Регистрирано краен време",
  note: "Забележка",
  day_and_date: "Ден / Дата",
  time: "Време",
  registered_on: "Регистрирано на",
  show_image: "Покажи снимка",
  role: "Роля:",
  direct_superior: "Пряк ръководител:",
  report_generated_on: "Отчетътът е създаден на:",
  small_at: "на",
  selected_period: "Избран период:",
  presence_details: "Подробности за присъствието",
  presence_type: "Тип присъствие",
  start_time: "Начален Час",
  end_time: "Краен Час",
  registered_start_time: "Регистрирано на",
  registered_end_time: "Регистрирано до",
  presence_image: "Снимка на присъствието",
  image_save_at: "Снимката е запазена в",
  small_on: "на",
  presence_image: "Снимка на присъствието",
  presence_report_excel: "AbSent Детайлен отчет",
  presence_report_pdf: "AbSent Отчет за присъствие",
  // Administrative Report
  administrators_report: "Доклад на администратора",
  attendance_images_reviewed: "Изображенията на присъстващите са прегледани",
  reviewed_by: "Прегледан от:",
  date_and_time_of_review: "Дата и час на прегледа:",
  image_of: "Изображение от:",
  image_saved_on: "Изображението е запазено в:",
  saved_from_device: "Запазено от устройство:",
  show_images: "Покажи снимки:",
  absent_attendance_images_reviewed: "AbSent Изображенията на присъстващите са прегледани",
  // Nationality And Religion
  settings: "Настройки",
  add_nationality: "Добавяне на Националност",
  add_religion: "Добавяне на Религия",
  nationality_religion: "Националност/Религия",
  nationality: "Националност",
  religion: "Религия",
  nationality_required: "Националността е задължителна",
  edit_nationality: "Редактиране на Националност",
  delete_this_nationality: "Сигурни ли сте, че искате да изтриете тази националност?",
  uneditable: "Не се редактира",
  delete_nationality: "Изтриване на Националност",
  nationality_successfully_deleted: "Националността е изтрита успешно",
  nationality_successfully_updated: "Националността е обновена успешно",
  other: "Друго",
  nationality_successfully_created: "Националността е създадена успешно",
  create_nationality: "Създаване на Националност",
  create_religion: "Създаване на Религия",
  edit_religion: "Редактиране на Религия",
  delete_religion: "Изтриване на Религия",
  religion_successfully_updated: "Религията е обновена успешно",
  delete_this_religion: "Сигурни ли сте, че искате да изтриете тази религия?",
  religion_successfully_deleted: "Религията е изтрита успешно",
  religion_successfully_created: "Религията е създадена успешно",
  religion_required: "Религия е задължителна",
  // Users
  users: "Потребители",
  active_users: "Активни потребители",
  deactivated_users: "Деактивирани потребители",
  blocked_users: "Блокирани потребители",
  email: "Имейл",
  phone: "Телефон",
  qr_code: "QR Код",
  work_rules: "Правила за работа",
  deactivated_at: "Деактивиран на",
  activate: "Активирай",
  are_you_sure_want_to_activate_this_user: "Сигурни ли сте, че искате да активирате този потребител?",
  yes_activate_it: "Да, активирай го!",
  user_was_successfully_activated: "Потребителят е активиран успешно",
  user_was_successfully_unblocked: "Потребителят е деблокиран успешно",
  are_you_sure_want_to_unblock_this_user: "Сигурни ли сте, че искате да отблокиране този потребител?",
  yes_unblock_it: "Да, деблокирай го!",
  unblock: "Отблокирай",
  user_was_successfully_blocked: "Потребителят е блокиран успешно",
  are_you_sure_want_to_block_this_user: "Сигурни ли сте, че искате да блокиране този потребител?",
  yes_block_it: "Да, блокирай го!",
  info_title: "Инфо",
  add_user: "Добавете потребител",
  download_all_qr_code: "Изтеглете всички QR Кодове",
  block: "Блокирай",
  edit_details: "Редактиране на детайлите",
  email_address_required: "Имейл адреса е задължителен",
  employee_start_date: "Дата на започване на работа",
  account_type: "Тип на профила",
  belongs_to_the_department: "Принадлежи към отдел",
  enter_account_details: "Въведете детайли за профила",
  belongs_to_the_team: "Принадлежи кън екип",
  employee_start_date_required: "Дата на започване на работа е задължителна",
  account_type_required: "Тип на Профила е задължително",
  belongs_to_department_required: "Принадлежи към отдел е задължително",
  team_required: "Принадлежи към екип е задължително",
  select_team: "Изберете Екип",
  select_department: "Изберете отдел",
  select_date_form: "Изберете Дата",
  enter_personal_details: "Въведете лични данни детайли за профила",
  full_name_to_display: "Име",
  display_job_position_users: "Показване на длъжността",
  full_name_required: "Име и Фамилия в документите е задължително",
  job_position_in_docs_required: "Длъжност в документите е задължително",
  display_job_position_required: "Показване на длъжността е задължително",
  full_name_to_display_required: "Името е задължително",
  select_religion: "Изберете Религия",
  select_country: "Изберете Държава",
  select_nationality: "Изберете Националност",
  differentiation_color: "Цвят за разпознаване",
  select_type: "Изберете Тип",
  administration: "Човешки ресурси",
  teamlead: "Ръководител на екипа",
  teammember: "Член на екипа",
  deplead: "Ръководител на отдел",
  sysadmin: "Системен администратор",
  user_successfully_created: "Потребителят е създаден успешно",
  date_invalid: "Невалидна дата",
  employee_end_date: "Крайна дата на трудовия договор",
  edit_user: "Редактиране на потребител",
  edit_account_details: "Редактиране данните на профила",
  edit_personal_details: "Редактиране на личните данни",
  user_successfully_updated: "Птребителят е променен успешно",
  please_fill_required_fields: "Моля, попълнете задължителните полета",
  review_and_change_rest_days: "Преглед и промяна на броя на почивните дни за:",
  rest_days_sucessfully_created: "Дните за почивка са създадени успешно",
  vacation_and_rest_days: "Годишна отпуска / Останали дни",
    "days": {
    "monday": "Понеделник",
    "tuesday": "Вторник",
    "wednesday": "Сряда",
    "thursday": "Четвъртък",
    "friday": "Петък",
    "saturday": "Събота",
    "sunday": "Неделя"
  },
  review_and_change_number_of_days: "Преглед и промяна на броя на дните за годишен отпуск:",
  date_of_acquisition: "Дата на придобиване",
  number_of_days_for_annual_leave_unused: "Брой дни за годишен отпуск - Неизползвани",
  number_of_days_for_annual_leave_pending: "Брой дни за годишен отпуск - За одобрение",
  number_of_days_for_annual_leave_used: "Брой дни за годишен отпуск - Използвани",
  actions: "Действия",
  add_row: "Добави",
  vacation_successfully_saved: "Правилата за годишен отпуск са променени успешно",
  vacation_successfully_deleted: "Правилата за ваканция бяха успешно изтрити",
  work_hours: "Работни часове",
  review_and_change_working_hours: "Преглед и промяна на работните часове за:",
  max_time_paid_break: "Максималното време за платена почивка",
  flexible_work_schedule: "Общо редовно работно време за гъвкаво работно време (работа+работа на терен+платена почивка)",
  flexible_working_hours: "Ако в даден ден има смяна, гъвкавото работно време не се зачита.",
  paid_hours_for_holiday_and_leave: 'Броят редовно платени часове за почивка и отпуск се изчислява според броя на "Общо редовни часове за гъвкав работен график".',
  automatic_presence_stop: "Активирайте автоматичното спиране на присъствието",
  enable_saving_images: "Активирайте запазването на изображения",
  disable_overtime_for_user: "Деактивирайте извънредния труд за потребителя",
  disable_presence_logging: "Деактивиране на регистрирането на присъствие:",
  using_the_web: "Използване на мрежата(WEB)",
  using_mobile_app: "Използване на мобилното приложение",
  max_time_for_auto_presence_stop_flexible_schedule: "Максималното време за автоматично спиране на присъствието за гъвкаво работно време ",
  work_field_work_paid_break: "(работа+работа на терен+платена почивка)",
  employee_no_scheduled_shift_auto_presence_stop_executed: "Когато служител няма планирана смяна, автоматичното спиране на присъствието се изпълнява според параметрите по-горе и на непрекъснат сегмент на присъствие (работа, почивка, работа на терен).",
  employee_has_scheduled_shift_max_time_not_taken_into_account: "Когато служител има планирана фиксирана или плъзгаща се смяна, параметърът за максимално време, дефиниран по-горе, не се взема предвид, но автоматичното спиране на присъствието се изпълнява след края на смяната и диапазона за закръгляване на крайното време.",
  user_has_existing_schedules_message: "Сигурни ли сте, че искате да запазите работните часове за този потребител?",
  yes_save_it: "Да,запазете го!",
  data_saved_successfully: "Работното време за потребителя беше успешно запазено",
  all_qr_codes: "Всички QR Кодове",
  // Departments
  departments: "Отдели",
  add_departments: "Добавете Отдел",
  department_manager: "Ръководител на отдел",
  default: "Основен",
  delete_this_department: "Сигурни ли сте, че искате да изтриете този отдел?",
  department_successfully_deleted: "Отделът е успешно изтрит",
  edit_department: "Редактиране на отдел",
  delete_department: "Изтриване на отдел",
  create_department: "Създаване на отдел",
  department_name: "Име на Отдела:",
  department_manager: "Ръководител на отдел:",
  department_members: "Членове на отдела:",
  department_name_required: "Името на отдела е задължително",
  department_lead_required: "Ръководителя на отдел трябва да се избере",
  department_successfully_created: "Отделът е създаден успешно",
  department_unchanged: "Отделът не е променен",
  department_successfully_updated: "Отделът е променен успешно",
  // Holidays
  for_all_citizens: "За всички граждани",
  year: "Година:",
  type_type: "Тип",
  add_holiday: "Добавяне на празник",
  delete_this_holiday: "Сигурни ли сте, че искате да изтриете този празник?",
  holiday_successfully_deleted: "Празникът е изтрит успешно",
  delete_holiday: "Изтриване на празник",
  create_holiday: "Създаване на празник",
  holiday_type: "Вид на празника",
  official_holiday: "Официален празник",
  ethnic_holiday: "Етнически",
  religious_holiday: "Религиозен",
  users_that_have_rest_days: "Има потребители, които имат почивни дни на избраната дата. Сигурни ли сте, че искате да изтриете тези почивни дни за всички потребители?",
  holiday_successfully_created: "Празникът е създаден успешно",
  date_required: "Датата е задължителна",
  description_required: "Описанието е задължително",
  holiday_type_required: "Типът на празника е задължителен",
  national_type_required: "Национален е задължителен",
  religious_type_required: "Религиозен е задължителен",
  national_type: "Национален",
  religious_type: "Религиозен",
  select_option: "Изберете опция",
  holidays: "Празници",

  // Register page
  register_company: "Регестрирайте вашата фирма",
  email_register: "Имейл",
  password: "Парола",
  confirm_password: "Потвърдете паролата",
  account_type_register: "Тип на профила",
  by_registering_in_absent: "Като се регистрирате в Absent, вие се съгласявате с:",
  terms_and_conditions_register: "правила и условия.",
  register_button: "Регистрирайте се",
  or_register: "или",
  login_to_your_account: "Влезте в профила си",
  email_verification: "Проверка на имейл",
  email_verified: "Имейлът е потвърден успешно!",
  your_email_successfully_verified: "Вашият имейл адрес е успешно потвърден. Вече можете да влезете.",
  email_verification_failed: "Потвърждението на имейла е неуспешно!",
  resend_verification_email: "Изпрати отново имейл за потвърждение",
  email_field_required: "Имейл",
  email_field_required: "Полето имейл е задължително",
  confirm_password_required: "Полето потвърдете паролата е задължително",
  role_required: "Полето тип на профила е задължително",
  agree_terms: "Полето правила и условия е задължително",
  password_mismatch: "Паролите не съвпадат",
  verifying_your_email: "Проверява се вашият имейл...",
  "recaptcha_verification_failed": "reCAPTCHA проверката е неуспешна",
  "failed_to_create_user": "Неуспешно създаване на потребител",
  "register_unexpected_error": "Възникна неочаквана грешка при регистрация",
  "registration_success": "Успешна регистрация! Моля, проверете имейла си, за да потвърдите акаунта си",
  "register_validation_failed": "Грешка при валидация на регистрация",
  "invalid_link": "Невалиден линк",
  "invalid_expired_link": "Линкът за потвърждение е невалиден или е изтекъл",
  "already_verified": "Вече потвърдено",
  "verification_success": "Проверката е успешна",
  "verification_failed": "Проверката е неуспешна",
  "verification_unexpected_error": "Възникна неочаквана грешка при проверка",
  "user_not_found": "Потребителят не е намерен",
  "already_verified": "Вече потвърдено",
  "verification_resent": "Потвърждението е изпратено отново, моля, проверете имейла си",
  "resend_validation_failed": "Повторното изпращане на потвърждението е неуспешно",
  "resend_unexpected_error": "Възникна неочаквана грешка при повторно изпращане",
  // LoginController
  invalid_credentials: "Невалидни идентификационни данни",
  you_dont_have_company_manager_account: "Нямате фирмен или мениджърски акаунт",
  // logoutController
  gate_does_not_exist: "Тази врата не съществува в нашата база данни!",
  user_is_logged_out: "Потребителят е излязъл", // User is logout
  unauthorized: "Неупълномощен",
  // ProfileApiController
  changing_starting_date:
    "За промяна на началната дата на служител, моля, откажете всичките му отсъствия!!",
  error: "Грешка",
  profile_was_successfully_updated: "Профилът е актуализиран успешно",
  password_changed_successfully: "Паролата е променена успешно",
  avatar_changed_successfully: "Аватарът е променен успешно",
  // PresenceApiController
  working_hours_allowed: "Броят на работните часове е по-голям от разрешения!!",
  not_found: "Не е намерено",
  // AbsenceApiController
  permission_to_schedule_rest_days:
    "Нямате права да планирате почивни дни за себе си",
  submit_absence_request:
    "За да изпратите заявка за отсъствие, избраните дати трябва да са само сегашни или бъдещи дати!",
  to_do_this_change:
    "За да направите тази промяна, моля, изтрийте всички отсъствия на този потребител",
  you_can_not_create_more_than_two_rest_days:
    "Не можете да създавате повече от два почивни дни",
  rest_day_successfully_created: "Почивните дни са създадени успешно",
  select_one_day_to_switch: "Можете да изберете само един ден за смяна!!!",
  human_resources_role_can_not_create_absence:
    "Човешки ресурси не може да създаде отсъствие за други потребители по-късно от:",
  submit_a_request_for_vacation:
    "За да подадете молба за годишен отпуск, избраната дата трябва да е поне 3 работни дни от днес",
  absence_was_successfully_created: "Отсъствието е създадени успешно",
  select_at_least_one_day:
    "Трябва да изберете поне един ден, за да подадете молба за Отпуск!",
  comment_successfully_changed: "Коментарът е успешно променен",
  documents_uploaded_successfully: "Документите са качени успешно",
  // ManagementApiController
  rest_day_was_successfully_rejected:
    "Седмичният почивен ден е отказан успешно",
  // ApiUserController
  company_does_not_exist: "Тази фирма не съществува в нашата база данни!",
  wrong_qr_code: "Грешен qr код!",
  user_does_not_exist: "Този потребител не съществува в нашата база данни!",
  device_id_is_required: "Изисква се ID на устройството!",
  device_id_does_not_exist:
    "Този идентификатор на устройство не съществува в нашата база данни!",
  // ApiPresenceController
  management_disabled_your_logging:
    "Ръководството на вашата компания деактивира регистрацията ви за присъствие!",
  gate_does_not_exist: "Тази врата не съществува в нашата база данни!",
  gate_is_not_active: "Тази врата не е активна!",
  // REQUESTS
  file_field_is_required: "Полето за файл е задължително.",
  file_must_be_an_image: "файлът трябва да е изображение.",
  jpeg_jpg_png_files_allowed: "Разрешени са само JPEG, JPG и PNG файлове.",
  file_size_1MB: "Размерът на файла не може да надвишава 1 MB.",
  jpg_jpeg_png_images_allowed:
    "Само JPG, JPEG и PNG \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 изображения са разрешени за качване",
  personal_days_type_field_required: "Полето тип лични дни е задължително.",
  switch_days_field_required: "Полето за дни за превключване е задължително.",
  comment_filed_required: "Полето за коментар е задължително.",
  invalid_document_format: "Невалиден формат на документа.",
  upload_up_to_5_files: "Можете да качите до 5 файла.",
  invalid_file_format: "Невалиден файлов формат.",
  jpeg_pdf_file_formats_allowed:
    "Разрешени са само JPEG и PDF файлови формати.",
  max_characters_allowed: "Разрешени са максимум 250 знака",
  required_field: "Задължително поле липсва или е празно.",
  invalid_input: "Невалиден вход",
  comment_required: "Коментарът е задължителен.",
  comment_250_characters: "Коментарът не може да надвишава 250 символа.",
  no_file_selected: "Не е избран файл.",
  jpg_jpeg_pdf_files_allowed: "Разрешени са само JPEG, JPG и PNG файлове.",
  uploaded_file_size_exceeds_allowed_limit:
    "Размерът на качения файл надвишава допустимия лимит.",
  first_name_required: "Името е задължително",
  first_name_must_be_at_least: "Минималната дължина на Името е :min знака",
  first_name_max_characters: "Максималната дължина на Името е max :max знака",
  valid_email_address: "Имейлът трябва да е с валиден имейл адрес",
  email_must_be_at_least: "Максималната дължина на имейл адрес е :max знака",
  birthday_required: "Датата на раждане е задължителна",
  country_required: "Държавата е задължителна",
  employment_start_date_required:
    "Датата на назначаване на работа е задължителна",
  full_name_in_docs_required: "Име и фамилия в документите са задължителни",
  full_name_in_docs_must_be_at_least:
    "Минималната дължина на Име и фамилия в документите e :min знака",
  full_name_in_docs_max_characters:
    "Максималната дължина на Име и фамилия в документите е :max знака",
  employee_position_in_docs_required: "Длъжността в документите е задължителна",
  employee_position_in_docs_must_be_at_least:
    "Минималната дължина на Длъжността в документите е :min знака",
  employee_position_in_docs_max_characters:
    "Максималната дължина на Длъжността в документите е max :max знака",
  employee_position_required: "Длъжността е задължителна",
  employee_position_must_be_at_least:
    "Минималната дължина на Длъжността е :min знака",
  employee_position_max_characters:
    "Максималната дължина на Длъжността е max :max знака",
  email_required: "Полето Имейл е задължителено",
  email_invalid: "Невалиден Имейл",
  email_has_already_been_taken: "Имейлът вече е зает",
  password_required: "Полето Парола е задължително",
  password_confiramtion:
    "Потвърждението на паролата и паролата трябва да съвпадат",
  password_confiramtion_required: "Потвърждение на Паролата е задължително",
  password_characters: "Минималната дължина на Паролата е 8 знака",
  passwrod_max_length: "Максималната дължина на Паролата е 30 знака",
  terms_and_conditions_required: "Условията и правилата се задължителни",
  user_role_required: "Тип на профила е задължителен.",
  old_password_required: "Полето Стара парола е задължително",
  user_language_changed_successfully: "Потребителският език е променен успешно",
  // yup password validations
  new_password_required: "Изисква се нова парола",
  repeat_password_required: "Изисква се повторна парола",
  old_and_new_password_must_be_different:
    "Старата и новата парола трябва да са различни",
  new_and_repeat_password_must_match:
    "Новата и повтарящата се парола трябва да съвпадат",
  password_must_be_at_least: "Паролата трябва да има поне 8 знака",
  password_must_contain:
    "Паролата трябва да съдържа поне една главна буква, една малка буква, едно число и един символ",
  field_required: "Това поле е задължително",
  // Cookie and Privacy Policy
  cookie_alert_text: `Ние използваме бисквитки, за да подобрим вашето използване на нашия сайт. За да научите повече, прочетете нашaта `,
  cookie_policy: "Политика на бисквитките",
  cookie_policy_title: "Политика на бисквитките",
  cookie_policy_user: `
     <p>
			Бисквитките се използват, за да се активира услугата, която се предоставя чрез сайта, както и бисквитки, които имат за цел да подобрят услугата и/или да отговарят по-добре на вашите нужди.
		</p> 
		<h5>Видове бисквитки, които използваме; </h5>

		<p>Бисквитките, които използваме, са строго задължителни бисквитки, които наблюдават услугата и без използването на които тя не би могла да функционира и следователно не може да бъде изключена.</p>
		<h5>Липса на потребителско съгласие</h5>

		<p>При всяко посещение на сайта от Потребителя се включват само строго задължителни бисквитки, без които услугата не може да бъде предоставена.</p>

		<p>По-долу е описание на бисквитките, използвани при използване на AbSent, тяхната функция:</p>
		
		<table class="table table-striped">
		  <thead>
		    <tr>
		      <th scope="col">No:</th>
		      <th scope="col">Име на бисквитката/файла/данните</th>
		      <th scope="col">Функция</th>
		    </tr>
		  </thead>
		  <tbody>
		    <tr>
			    <th scope="row">1</th>
			    <td>XSRF-TOKEN</td>
			    <td>
			    	Защита на системата под формата на произволен низ, който предпазва сайта от хакерски атаки, без да отнема личната ви информация по никакъв начин.
			    </td>
		    </tr>
		    <tr>
			    <th scope="row">2</th>
			    <td>absent_session</td>
			    <td>
					Запазва системни данни, без да взема лична информация по никакъв начин.
			    </td>
		    </tr>
		    <tr>
			    <th scope="row">3</th>
			    <td>_ga, _gid</td>
			    <td>
					Тези бисквитки се използват за събиране на информация за това как посетителите използват нашия сайт. Ние използваме информацията, за да съставим отчети и да ни помогне да подобрим сайта. Бисквитките събират информация в анонимна форма, включително броя на посетителите на сайта, откъде идват посетителите географски, както и посетените страници, устройствата и браузърите, използвани от посетителите.
			    </td>
		    </tr>
		    <tr>
				<th scrop="row">3</th>
				<td>absent-cookie-policy-consent</td>
				<td>
					Тази бисквитка се използва за записване дали посетител е видял лентата за известия относно нашата политика за бисквитки.
				</td>
		    </tr>
		  </tbody>
		</table>
      <p>
          Последна актуализация на: 01/01/2020.
      </p>
    `, //end of user cookie policy description

  i_agree: "Съгласен съм",

  privacy_policy_title: "Политика за поверителност",
  privacy_policy_user: `
      <p>
        Тази политика за поверителност обяснява как ние, Компанията за инженеринг SENTICE TECH LLC Скопие, действайки като Обработващ (наричан по-долу: Sentice), събираме и обработваме данни за вас и вашето използване на мобилното и уеб приложение AbSent (наричано по-долу: Лични данни), в за да Ви предоставим нашата услуга, като служители на Вашия Работодател.
      </p>

      <p>
           За да бъдем по-конкретни, тази политика за поверителност обяснява как събираме, използваме и обработваме лични данни и случаите, когато можем да разкрием лични данни във връзка с използването на услугата от Ваша страна чрез AbSent – ​​приложение за управление на отсъствието в съответствие със законите, съгласувано задължения и съвместни законни интереси (записване на отсъствие от работа).

      </p>

      <p>
          Ние получаваме някои от вашите данни от вашия работодател, който записва данните в AbSent, за да създаде вашия личен потребителски акаунт, с който можете самостоятелно да продължите да използвате услугата, като изпращате отсъствия от работа.
      </p>

      <h5>Как събираме и използваме лични данни</h5>
      <p>
           Събраните данни се получават от Вашия работодател, който ни предоставя данните, за да създадем Вашия личен потребителски акаунт; за постигането на това Работодателят или упълномощено лице въвежда самостоятелно данните в Приложението: Отсъства.
      </p>
      <p>
           Получаваме следните данни:
      </p>
      <ul class="dashed">
          <li>
               име и фамилия,
          </li>
          <li>
             телефонен номер,
          </li>
          <li>
             дата на раждане,
          </li>
          <li>
             националност и религия.
          </li>
      </ul>

      <p>
           Цел: Ние използваме Вашите лични данни изключително за изпълнение на договорените задължения с Вашия Работодател, както и за да Ви предоставим услугата за управление на Вашите лични отсъствия чрез AbSent.
      </p>
      <p>
            Ние събираме вашите лични данни, които вашият служител и вие ни предоставяте доброволно.
        </p>

        <h5>Автоматично събиране на данни</h5>
        <p>
           Данните се събират и автоматично, чрез бисквитки. Тези данни се използват с цел предоставяне и подобряване на услугата.
        </p>
        <p>
            Данните не включват Вашето съдържание или данни, генерирани от Вас.
        </p>
        <p>
            За допълнителна информация относно това как данните се събират и обработват чрез автоматично събиране с помощта на бисквитки, прочетете <a href="/cookie-policy" target="_blank">Правилата за бисквитките</a>.
        </p>
        <p>
            Освен използването на гореспоменатите данни, когато възникне необходимост, ние можем да използваме и IP адреса, който използвате за достъп до услугата, както и други данни, които могат да разкрият Вашата самоличност, само когато това е необходимо и задължително, за да спазим Законът.
        </p>
        <h5>Съхранение и трансфер на данни</h5>
        <h6>За по-добра и пълна защита Компанията използва система за архивиране, базирана в облак, на сървъри, разположени в Европейския съюз, по-точно във Франкфурт, Германия.</h6>
        <h6>По отношение на обработката на Вашите данни Вие имате следните права:</h6>
        <p>
            <ul class="dashed">
                <li>право на достъп и редактиране на моите лични данни;</li>
                <li>
                   правото да блокирам обработването на личните ми данни поради конкретни причини;
                </li>
                <li>
                    право на възражение, както и право на прехвърляне на личните ми данни към друг администратор, в подходящата форма;
                </li>
            </ul>
        </p>
        <h5>Право на достъп до лични данни</h5>
        <p>
            Право на достъп: с тази политика Ви информираме, че не въвеждаме, актуализираме и/или изтриваме лични данни, въведени от Вашия Работодател или лично от Вас. Ако поискате право на достъп, актуализиране или изтриване на данни, това може да бъде постигнато чрез вашия Работодател, който е въвел данните, т.е. който има право да въвежда, актуализира и изтрива данни вместо вас.
        </p>

        <p>
            Ние съхраняваме въведените от Вас или Вашия работодател данни само на сървър, за да изпълним договорените задължения, за да можете да използвате услугата. Тези данни се съхраняват криптирани и не са разбираеми.
        </p>

        <h5>Защита на данните</h5>
        <p>
            Ние въвеждаме разумни мерки за осигуряване на подходяща физическа, техническа и електронна защита на данните.
        </p>
        <p>
            Ние прилагаме мерки за безопасност за физическа и техническа защита на данните от загуба, унищожаване и неоторизиран достъп, публикуване или неоторизирано влизане.
        </p>
        <p>
            Въпреки тези мерки, няма мярка за безопасност, която да гарантира пълна (100%) защита през целия период от време.
        </p>

        <h5>Начин на уведомяване при промени в политиката за поверителност</h5>

        <p>
            Актуализации на политиката за поверителност. Тази политика за поверителност може да претърпява определени актуализации от време на време в съответствие с промените в разпоредбите за защита на личните данни. Ние ще ви информираме за всяка промяна, която се отнася до начина, по който се манипулират вашите събрани преди това данни, и ще ви бъде дадена възможност да изберете дали искате да продължите да ги използвате.
        </p>

        <p>
            Последна актуализация на 1/1/2020
        </p>
    `, //end of user privacy policy description
  privacy_policy_user_modal: `
      <p>
        Тази политика за поверителност обяснява как ние, Компанията за инженеринг SENTICE TECH LLC Скопие, действайки като Обработващ (наричан по-долу: Sentice), събираме и обработваме данни за вас и вашето използване на мобилното и уеб приложение AbSent (наричано по-долу: Лични данни), в за да Ви предоставим нашата услуга, като служители на Вашия Работодател.
      </p>

      <p>
           За да бъдем по-конкретни, тази политика за поверителност обяснява как събираме, използваме и обработваме лични данни и случаите, когато можем да разкрием лични данни във връзка с използването на услугата от Ваша страна чрез AbSent – ​​приложение за управление на отсъствието в съответствие със законите, съгласувано задължения и съвместни законни интереси (записване на отсъствие от работа).

      </p>

      <p>
          Ние получаваме някои от вашите данни от вашия работодател, който записва данните в AbSent, за да създаде вашия личен потребителски акаунт, с който можете самостоятелно да продължите да използвате услугата, като изпращате отсъствия от работа.
      </p>

      <h5>Как събираме и използваме лични данни</h5>
      <p>
           Събраните данни се получават от Вашия работодател, който ни предоставя данните, за да създадем Вашия личен потребителски акаунт; за постигането на това Работодателят или упълномощено лице въвежда самостоятелно данните в Приложението: Отсъства.
      </p>
      <p>
           Получаваме следните данни:
      </p>
      <ul class="dashed">
          <li>
               име и фамилия,
          </li>
          <li>
             телефонен номер,
          </li>
          <li>
             дата на раждане,
          </li>
          <li>
             националност и религия.
          </li>
      </ul>

      <p>
           Цел: Ние използваме Вашите лични данни изключително за изпълнение на договорените задължения с Вашия Работодател, както и за да Ви предоставим услугата за управление на Вашите лични отсъствия чрез AbSent.
      </p>
      <p>
            Ние събираме вашите лични данни, които вашият служител и вие ни предоставяте доброволно.
        </p>

        <h5>Автоматично събиране на данни</h5>
        <p>
           Данните се събират и автоматично, чрез бисквитки. Тези данни се използват с цел предоставяне и подобряване на услугата.
        </p>
        <p>
            Данните не включват Вашето съдържание или данни, генерирани от Вас.
        </p>
        <p>
            Освен използването на гореспоменатите данни, когато възникне необходимост, ние можем да използваме и IP адреса, който използвате за достъп до услугата, както и други данни, които могат да разкрият Вашата самоличност, само когато това е необходимо и задължително, за да спазим Законът.
        </p>
        <h5>Съхранение и трансфер на данни</h5>
        <h6>За по-добра и пълна защита Компанията използва система за архивиране, базирана в облак, на сървъри, разположени в Европейския съюз, по-точно във Франкфурт, Германия.</h6>
        <h6>По отношение на обработката на Вашите данни Вие имате следните права:</h6>
        <p>
            <ul class="dashed">
                <li>право на достъп и редактиране на моите лични данни;</li>
                <li>
                   правото да блокирам обработването на личните ми данни поради конкретни причини;
                </li>
                <li>
                    право на възражение, както и право на прехвърляне на личните ми данни към друг администратор, в подходящата форма;
                </li>
            </ul>
        </p>
        <h5>Право на достъп до лични данни</h5>
        <p>
            Право на достъп: с тази политика Ви информираме, че не въвеждаме, актуализираме и/или изтриваме лични данни, въведени от Вашия Работодател или лично от Вас. Ако поискате право на достъп, актуализиране или изтриване на данни, това може да бъде постигнато чрез вашия Работодател, който е въвел данните, т.е. който има право да въвежда, актуализира и изтрива данни вместо вас.
        </p>

        <p>
            Ние съхраняваме въведените от Вас или Вашия работодател данни само на сървър, за да изпълним договорените задължения, за да можете да използвате услугата. Тези данни се съхраняват криптирани и не са разбираеми.
        </p>

        <h5>Защита на данните</h5>
        <p>
            Ние въвеждаме разумни мерки за осигуряване на подходяща физическа, техническа и електронна защита на данните.
        </p>
        <p>
            Ние прилагаме мерки за безопасност за физическа и техническа защита на данните от загуба, унищожаване и неоторизиран достъп, публикуване или неоторизирано влизане.
        </p>
        <p>
            Въпреки тези мерки, няма мярка за безопасност, която да гарантира пълна (100%) защита през целия период от време.
        </p>

        <h5>Начин на уведомяване при промени в политиката за поверителност</h5>

        <p>
            Актуализации на политиката за поверителност. Тази политика за поверителност може да претърпява определени актуализации от време на време в съответствие с промените в разпоредбите за защита на личните данни. Ние ще ви информираме за всяка промяна, която се отнася до начина, по който се манипулират вашите събрани преди това данни, и ще ви бъде дадена възможност да изберете дали искате да продължите да ги използвате.
        </p>

        <p>
            Последна актуализация на 1/1/2020
        </p>
    `,
  OK: "OK",

  no_right_to_use_vacation: "Нямате право да заявявате ваканционни дни в избрания период. Моля, свържете се с ръководството на вашата компания или с HR за поддръжка.",
  cannot_take_vacation_in_selected_period:
    "Не можете да вземете отпуск в избрания период",
  days_exceed_annual_limit:
    "Броят на заявените дни е по-голям от броя на дните годишен отпуск за този период",
  overlapping_personal_days:
    "Крайният период на личните дни се припокрива с друг отпуск.",
  overlapping_absence: "Потребителят вече има отсъствие в този период.",
  overlapping_period_or_switch_day:
    "Потребителят вече има отпуск с този период / ден за прехвърляне.",
  wrong_old_password: "Грешна Стара парола.",

  re_type_new_password: "Въведете повторно новата парола",
  save: "Запази",
  successfully_logged_in: "Влезли сте успешно, моля променете паролата си",
  error_try_again_later: "Нещо се обърка. Моля, опитайте отново по-късно.",
  error_creating_absence: "Грешка при създаване на отсъствие",
  absence_declined: "Отсъствието е отказано.",
  absence_approved:"Отсъствието е одобрено успешно",
  expired_password:"Вашата парола е изтекла, моля, променете я.",
  current_password:"Настояща парола",
  confirm_new_password:"Потвърждение на новата парола",
  reset_password:"Нулиранр на Парола",

  login: "Вход",
  page_not_found: "Страницата не е намерена.",
  go_back_to_home_page: "Връщане към началната страница",

  last_reason_for_update: "Последна причина за актуализация",
  reason_for_update: "Причина за актуализация",
  comment_for_this_presence: "Коментар за това присъствие",
  absent_members: "член/ове отсъстват в този ден",

  Other: "Друго",

  //months - short translation
  Jan: "Яну",
  Feb: "Фев",
  Mar: "Мар",
  Apr: "Апр",
  May: "Май",
  Jun: "Юни",
  Jul: "Юли",
  Aug: "Авг",
  Sep: "Сеп",
  Oct: "Окт",
  Nov: "Ное",
  Dec: "Дек",

  "absences": {
    "Annual leave Unused": "Годишен отпуск - Неизползван",
    "Annual leave Pending": "Годишен отпуск - За одобрение",
    "Annual leave Used": "Годишен отпуск - Използван",
    "Name of vacation": "Назив на годишен одмор",
    "Personal days": "Платен отпуск",
    "Sick leave": "Отпуск по болест",
    "Business trip": "Командировка",
    "Work from home": "Работа от вкъщи",
    "Extra days": "Допълнителни дни",
    "Paid parental leave": "Платено породилно отсуство",
    "Unpaid parental leave": "Неплатено породилно отсуство",
    "Unpaid leave": "Неплатен отпуск",
  },

  "presence_report_names": {
    "Person": "Лице",
    "Work": "Работа",
    "Paid Break": "Платена почивка",
    "Field work": "Работа на терен",
    "Absence": "Отсъствие",
    "Holiday": "Празник",
    "Total regular time": "Общо редовно време",
    "Expected regular time": "Очаквано редовно време",
    "Expected and total time difference": "Разлика между очакваното и общото време",
    "Total scheduled": "Общо планирано",
    "Overtime": "Извънреден труд",
    "Expected and total time difference with overtime": "Разлика между очакваното, общото време и извънреден труд",
    "Presence on night work": "Присъствие по време на нощна работа",
    "Presence on absence": "Работа по време на отсъствие",
    "Presence on holiday": "Работа по време на празник",
    "Presence on rest day": "Присъствие в почивен ден",
    "Total Logged Hours": "Общо регистрирани часове",
    "Private exit": "Излизане",
    "Unauthorized Absence": "Неразрешено отсъствие",
    "Exceeded break": "Превишена почивка",
    "Unpaid absence": "Неплатено отсъствие",
    "Day": "Ден",
    "Date": "Дата",
    "Schedule start time": "Планиран начален час",
    "Logged start time": "Регистрирано начално време",
    "Schedule end time": "Планиран краен час",
    "Logged end time": "Регистрирано краен време",
   "Work": "Работа",
    "Paid Break": "Платена почивка",
    "Field work": "Работа на терен",
    "Absence": "Отсъствие",
    "Holiday": "Празник",
    "Total logged time": "Общо редовно време",
    "Expected regular time": "Очаквано редовно време",
    "Expected and total time difference": "Разлика между очакваното и общото време",
    "Total schedule time": "Общо планирано",
    "Overtime": "Извънреден труд",
    "Expected and total time difference with overtime": "Разлика между очакваното, общото време и извънреден труд",
    "Presence on night work": "Присъствие по време на нощна работа",
    "Presence on absence": "Работа по време на отсъствие",
    "Presence on holiday": "Работа по време на празник",
    "Presence on rest day": "Присъствие в почивен ден",
    "Total Logged Hours": "Общо регистрирани часове",
    "Private exit": "Излизане",
    "Unauthorized Absence": "Неразрешено отсъствие",
    "Exceeded break": "Превишена почивка",
    "Unpaid absence": "Неплатено отсъствие",
    "Note": "Забележка",
  },
  'Default' : 'Основен',
  'Deactivated' : 'Деактивиран',
  'Mon' : 'Пон',
  'Tue' : 'Вто',
  'Wed' : 'Сря',
  'Thu' : 'Чет',
  'Fri' : 'Пет',
  'Sat' : 'Съб',
  'Sun' : 'Нед',
  'Work' : 'Работа',
  'Break' : 'Платена почивка',
  'Field work' : 'Работа на терен',
  'Private exit' : 'Излизане',
  'Work on absence' : 'Работа по време на отсъствие',
  'Break on absence' : 'Платена почивка по време на отсъствие',
  'Field work on absence' : 'Работа на терен по време на отсъствие',
  'Work on holiday' : 'Работа по време на празник',
  'Break on holiday' : 'Платена почивка по време на празник',
  'Field work on holiday' : 'Работа на терен по време на празник',
  'Unauthorized Absence' : 'Неразрешено отсъствие',
  'Work on rest day' : 'Работа по време на почивен ден',
  'Field work on rest day' : 'Работа на терен по време на почивен ден',
  'Break on rest day' : 'Платена почивка по време на почивен ден',
  'Work on night work' : 'Присъствие по време на нощна работа',
  'Field work on night work' : 'Работа на терен по време на нощна работа',
  'Break on night work' : 'Платена почивка по време на нощна работа',
  // "teamTranslation": {
  //   "Default": "Основен",
  // },
  //   "departmentTranslation": {
  //   "Default": "Основен",
  // }
   "allRoles": {
    "Manager": "Управител",
    "Chairman": "Председател",
    "Human Resources": "Човешки ресурси",
    "Team Lead": "Ръководител на екипа",
    "Team Member": "Член на екипа",
    "Department Lead": "Ръководител на отдел",
    "System Administrator": "Системен администратор"
  },
  manager: "Управител",
  owner: "Председател",
  "roles": {
    "General Manager-manager": "Управител",
    "System Administrator-sysadmin": "Системен администратор",
    "Chairman-owner": "Председател",
    "Department Manager-deplead": "Ръководител на отдел",
    "Team Lead-teamlead": "Ръководител на екипа",
    "Team Member-teammember": "Член на екипа",
    "Human Resources-administration": "Човешки ресурси",
    "Генерален менаџер-manager": "Управител",
    "Претседател-owner": "Председател",
    "Човечки ресурси-administration": "Човешки ресурси",
    "Менаџер на оддел-deplead": "Ръководител на отдел",
    "Тим лидер-teamlead": "Ръководител на екипа",
    "Член на тим-teammember": "Член на екипа",
    "Систем aдминистратор-sysadmin": "Системен администратор",
    "Управител-manager": "Управител",
    "Системен администратор-sysadmin": "Системен администратор",
    "Човешки ресурси-administration": "Човешки ресурси",
    "Председател-owner": "Председател",
    "Ръководител на отдел-deplead": "Ръководител на отдел",
    "Ръководител на екипа-teamlead": "Ръководител на екипа",
    "Член на екипа-teammember": "Член на екипа"
  },
  vacation_period_desc: "Период на ползване на отпуск",
  document_full_name_desc: "Пълното име на заявителя, въведено на местния му език",
  birthday_desc: "Датум на роденден на подносителот",
  document_job_position_desc: "Длъжност на заявителя, която е въведена на местния му език",
  requested_days_desc: "Брой дни, поискани от заявителя",
  next_day_desc: "Изчислен ден за заявителя, когато трябва да се върне на работа",
  display_leave_type_desc: "Вид на отпуска",
  start_day_desc: "Начална дата на заявката за отсъствие",
  end_day_desc: "Крайна дата на заявката за отсъствие",
  display_full_name_desc: "Пълно име на заявителя",
  display_job_position_desc: "Длъжност на заявителя",
  email_desc: "Имейл на заявителя",
  team_desc: "Екип на заявителя",
  empl_start_day_desc: "Дата на започване на работа на заявителя",
  phone_desc: "Телефон на заявителя",
  document_leave_type_desc: "Тип отпуск на заявителя, който е въведен на неговия местен език",
  absent_created_desc: "Дата на създаване на отсъствието",
  absent_change_status_desc: "Дата, когато е променен статуса на отсъствието",
  submited_tag_desc: "Подадено от",
  gm_tag_desc: "Етикет за Генерален директор",
  hr_tag_desc: "Етикет за Човешки ресурси",
  dl_tag_desc: "Етикет за Ръководител на отдел",
  tl_tag_desc: "Етикет за Ръководител на екип",
  submited_time_tag_desc: "Времето, когато е подадена заявката",
  gm_approved_time_tag_desc: "Времето, когато заявката е одобрена от Генералният директор",
  hr_approved_time_tag_desc: "Времето, когато заявката е одобрена от Човешки ресурси",
  dl_approved_time_tag_desc: "Времето, когато заявката е одобрена от Ръководителят на отдела",
  tl_approved_time_tag_desc: "Времето, когато заявката е одобрена от Ръководителят на екипа",
  absence_comment_desc: "Коментар на молбата за отпуск",
  submited_date_tag_desc: "Датата, когато е подадена заявката",
  gm_approved_date_tag_desc: "Датата, когато заявката е одобрена от Генералният директор",
  hr_approved_date_tag_desc: "Датата, когато заявката е одобрена от Човешки ресурси",
  dl_approved_date_tag_desc: "Датата, когато заявката е одобрена от Ръководителят на отдела",
  tl_approved_date_tag_desc: "Датата, когато заявката е одобрена от Ръководителят на екип",
  vacation_title_desc: "Заглавие на годишния отпуск",
  copy_tag: "Копирай етикета",
  upload_annual_leave_template: "Качете образец за годишен отпуск",
  upload_paid_holidays_template: "Качете образец за платен отпуск",
  upload_work_from_home_template: "Прикачете образец за работа от вкъщи",
  download_template: "Изтеглете образеца",
  drag_or_click_to_upload: "Пуснете файлове тук или щракнете, за да качите образеца.",
  how_to_make_documents: "Как да направите документите?",
  document_templates_help_1: "За да генерирате автоматично документите на служителите, трябва да добавите образци за документи.",
  document_templates_help_2: "Тези образци трябва да съдържат някои от изброените тук етикети по ваш избор, според вашите нужди.Разбира се, не е задължително да използвате всички, но е много вероятно да искате да използвате някои от тях.",
  document_templates_help_3: "На връзката по-долу можете да изтеглите примерен образец.",
  document_templates_help_4: "Дори и да не искате да използвате всички образци на документи, моля, качете празни .docx файлове",
  download_example_template: "Изтеглете примерен образец",
  help: "Помощ",
  not_uploaded_annual_leave_template: "Образецът за годишен отпуск не е поставен",
  not_uploaded_paid_holidays_template: "Образецът за платен отпуск не е поставен",
  not_uploaded_work_from_home_template: "Образецът за работа от вкъщи не е поставен",
  company: "Фирма",
  document_templates: "Образци на документи",
  document_templated_uploads: "Качване на образци на документи",
  tags: "Етикет",
  tags_description: "Описание на етикета",
  template_successfully_uploaded: "Образецът беше успешно качен",
  upload_failed: "Качването не успя",
  copied_to_clipboard: "Етикетът е копиран!",
  departmentTranslation: {
    "Default": "Основен", 
    "Основен": "Основен", 
    "Основен": "Основен", 
  },
  teamTranslation: {
    "Default": "Основен", 
    "Основен": "Основен", 
    "Основен": "Основен", 
  },
  details: "Детайли",
  company_details: "Детайли за компанията",
  name: "Име",
  address: "Адрес",
  leader_of_default_team_and_department: "Ръководител на основния екип и отдел: ",
  city: "Град",
  tax_number: "Данъчен номер",
  enter_company_tax_number: "Въведете данъчния номер на компанията",
  optional: "(Не е задължително)",
  country: "Държава",
  company_logo: "Лого на компанията",
  change_logo: "Промени логото",
  upload_logo: "Качи лого",
  save: "Запазване",
  select_country: "Избери държава",
  search: "Търси",
  frequent_countries: "Чести държави",
  all_countries: "Всички държави",
  manager_required: "Генералният мениджър е задължителен",
  name_required: "Името е задължително",
  address_required: "Адресът е задължителен",
  city_required: "Градът е задължителен",
  country_required: "Държавата е задължителна",
  no_changes_to_save: "Няма промени за запазване",
  failed_to_load_company_details: "Неуспешно зареждане на данните за компанията",
  company_updated_successfully: "Компанията беше успешно актуализирана",
  failed_to_update_company: "Неуспешна актуализация на компанията",
  validation_error: "Грешка при валидация",
  please_fill_required_fields: "Моля, попълнете задължителните полета",
  logo_must_be_image: "Логото трябва да бъде изображение",
  info_title: "Информация",
  error: "Грешка",
  success: "Успешно",
    login: {
    "join_system": "ПРИСЪЕДИНЕТЕ СЕ КЪМ НАШАТА СТРАХОТНА СИСТЕМА ЗА УПРАВЛЕНИЕ НА ОТСЪТСТВИЯТА",
    "email": "Имейл",
    "password": "Парола",
    "remember_me": "Запомни ме",
    "forgot_password": "Забравена парола?",
    "2fa_code": "Код за двуфакторна автентикация",
    "resending": "Изпращане на код...",
    "resend_code": "Изпрати отново кода",
    "login": "ВЛИЗАНЕ",
    "verify": "ВЕРИФИКАЦИЯ",
    "invalid_or_expired_2fa_token": "Невалиден 2FA код.",
    "resend_failed": "Неуспешно изпращане на кода.",
    "user_is_blocked": "Потребителят е блокиран.",
    "failed": "Неуспешно влизане",
    "invalid_2fa": "Невалиден 2FA код.",
    "resend_failed": "Неуспешно изпращане на кода.",
    "password_min_length": "Паролата трябва да е поне 8 символа.",
    "password_uppercase": "Паролата трябва да съдържа поне една главна буква.",
    "password_lowercase": "Паролата трябва да съдържа поне една малка буква.",
    "password_number": "Паролата трябва да съдържа поне една цифра.",
    "password_special": "Паролата трябва да съдържа поне един специален символ.",
    "passwords_do_not_match": "Паролите не съвпадат.",
    "password_reset_success": "Паролата беше успешно нулирана!",
    "user_not_found": "Потребителят не е намерен.",
    "invalid_code": "Невалиден код.",
    "invalid_or_expired_code": "Невалиден или изтекъл код.",
    "email_not_verified": "Имейлът не е потвърден.",
    "user_is_blocked": "Потребителят е блокиран.",
    "code_valid": "Кодът е валиден.",
    "password_expired": "Вашата парола е изтекла. Моля, нулирайте я.",
    "password_reset_email_sent": "Изпратен е имейл за нулиране на паролата.",
    "reset_code_sent": "Изпратен е код за нулиране.",
    "send_reset_code": "Изпрати код за ресетиране",
    "back_to_login": "Назад на најава",
    "otp_timer": "OTP Таймер",
    "verify_code": "Верификувай код",
    "reset_password": "Ресетирай лозинка",
    "new_password": "Нова лозинка",
    "confirm_password": "Потвърди нова лозинка",
  },
  languages: {
    "gb": "English",
    "mk": "Македонски",
    "bg": "Български",
  },
  loginPage: "Вход",
  terms_and_conditions_title: "Условия и Правила",
};
